import { useState } from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import './App.scss';
import DealerAssignForm from './pages/Signup/DealerAssignForm';
import OTPForm from './pages/Signup/OTPForm';
import OTPEmailForm from './pages/Signup/OTPEmailForm';
import SigninForm from './pages/Signup/SigninForm';
import Signup from './pages/Signup/Signup';
import SignupForm from './pages/Signup/SignupForm';
import Message from './pages/Signup/Message';
import ForgotPasswordForm from './pages/Signup/ForgotPasswordForm';
import ResetPasswordForm from './pages/Signup/ResetPasswordForm';
import axios from 'axios';

function App() {

  // const [user, setUser] = useState({ "id": 9694, "name": "Ciaran McCaughey", "email": "ciaran@evalexpert.com.au", "api_key": "05da33cbff8e907a898cff947d8784ad", "status": 1, "created_at": "2021-08-05 03:33:37", "expirary": "2021-08-04 03:33:37", "ccy": "$", "nopricing": null, "DealerSE": null, "DealerMgr": null, "ManufacturerID": null, "countrycode": "AU", "PlanID": null, "PPSR": "1", "GroupDealerID": null, "updateRBCode": null, "AuctionEnabled": null, "EditUserPricing": null, "TendersAdmin": null, "ViewTenders": null, "activeEval": 1, "activeDrive": null, "activeDataPortal": null, "activeDealerEval": null, "activeDealerDrive": null, "activeDealerDataPortal": null, "driveExpertId": null, "country": "Australia", "phcode": 61, "phone": 424795782, "timezone": null, "dealerUid": null, "appPricePlan": null, "liteUpgradePrice": null });
  const [user, setUser] = useState();
  const [password, setPassword] = useState();

  const [showMessage, setShowMessage] = useState(false);
  
  const [message, setMessage] = useState('');
  const [product, setProduct] = useState('Insights');

  const showInfo = (text) => {
    setShowMessage(true);
    setMessage(text);
    setTimeout(() => {
      setShowMessage(false);
      setMessage('');
    }, 3000);
  }

  const setVerified = async (field) => {
    const headers = { 'Authorization': user.api_key }
    const res = await axios.post('https://evalexpert.io/v1/setVerified', { userId: user.id, field: field, verified: 1 }, { headers: headers })
    const data = res.data;
  }

  const resendCode = async (method) => {
    const headers = { 'Authorization': user.api_key }
    const res = await axios.post('https://evalexpert.io/v1/twoFactorAuth', { requestReason: product + " Sign Up Verify " + method, product, method: method, ignoreRecent: true }, { headers: headers })
    const data = res.data;
  }

  const login = async () => {
    console.log('login called', user.email, password);
    const DASHBOARD_URL = SERVER_URL+'/insightsdashboard/pages/dashboard/'
    let rememberme = false ? 1 : '';
    const postData = { email: user.email, password, rememberme: rememberme };
    const res = await axios.post(SERVER_URL+'/insightsdashboard/pages/server/login.php?action=login', postData);
    const data = res.data;
    if (data.id) {
        window.location.href = SERVER_URL+'/insightsdashboard/pages/dashboard/price-guide.php';
    }

  }

  return (
    <Router>
      {showMessage && <Message text={message} dismiss={() => { setShowMessage(''); setMessage(false) }} />}
      <Signup product={product} setProduct={setProduct} >
          <Switch>
            <Route path="/insightsdashboard/pages/dashboard/otp/email" exact>
              <OTPEmailForm user={user} setVerified={setVerified} resendCode={resendCode} showInfo={showInfo} product={product} />
            </Route>
            <Route path="/insightsdashboard/pages/dashboard/otp/phone" exact>
              <OTPForm user={user} setVerified={setVerified} resendCode={resendCode} showInfo={showInfo} product={product}/>
            </Route>
            <Route path="/insightsdashboard/pages/dashboard/dealer" exact>
              <DealerAssignForm user={user} product={product} login={login} />
            </Route>
            <Route path="/insightsdashboard/pages/dashboard/forgot" exact>
              <ForgotPasswordForm user={user} showInfo={showInfo} product={product} />
            </Route>
            <Route path="/insightsdashboard/pages/dashboard/reset/:token" exact>
              <ResetPasswordForm user={user} product={product}/>
            </Route>
            <Route path={["/insightsdashboard/pages/dashboard/signup/", "/insightsdashboard/pages/dashboard/signup/", "/insightsdashboard/pages/dashboard/signup/:p"]}>
              <SignupForm setUser={setUser} showInfo={showInfo} product={product} setProduct={setProduct} resendCode={resendCode} setPassword={setPassword} />
            </Route>
            <Route path={["/", "/insightsdashboard/pages/dashboard/"]}>
              <SigninForm user={user} product={product} />
            </Route>
          </Switch>
      </Signup>
    </Router>
  );
}

export default App;
